import React, { memo, useMemo } from 'react'
import { Box } from '@mui/material'
import { ChartViewKey } from '../../assets/constants'
import { Security } from '../../proto/generated/security'
import { SuperChartConfiguration_DateRange } from '../../proto/generated/superchart-page'
import ChartWrapper from '../chartV2/chartWrapper/chartWrapper'
import { getStableOverviewSecurityList, overviewDateRangeKey } from './overviewChartProps'

export type OverviewChartPanelProps = {
    security: Security
    dateRange?: SuperChartConfiguration_DateRange
}

const EMPTY_COMPARABLE_SECURITIES: Security[] = []

const OverviewChartPanel = ({ security, dateRange }: OverviewChartPanelProps) => {
    const securityList = useMemo(() => getStableOverviewSecurityList(security), [security.exchange, security.code])

    return (
        <Box sx={{ height: '100%', width: '100%' }}>
            <ChartWrapper
                viewKey={ChartViewKey.OVERVIEW}
                securityList={securityList}
                comparableSecurities={EMPTY_COMPARABLE_SECURITIES}
                mode="SINGLE"
                hideActions
                expression=""
                hideChartFooter
                showMetadata={false}
                primary={false}
                primaryScaleId="LEFT"
                hideLeftScale
                hideRightScale
                disableScroll
                disableVolumeOnLoad
                selectedDateRange={dateRange}
            />
        </Box>
    )
}

const overviewChartPanelPropsAreEqual = (prev: OverviewChartPanelProps, next: OverviewChartPanelProps) =>
    prev.security.exchange === next.security.exchange &&
    prev.security.code === next.security.code &&
    overviewDateRangeKey(prev.dateRange) === overviewDateRangeKey(next.dateRange)

export default memo(OverviewChartPanel, overviewChartPanelPropsAreEqual)
